import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BreadcrumbComponent } from "../breadcrumb/breadcrumb.component";
import { CommonSvgIconComponent } from "../common-svg-icon/common-svg-icon.component";
import { FeatherIconsComponent } from "../feather-icons/feather-icons.component";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { BookmarkComponent } from "./bookmark/bookmark.component";
import { CartComponent } from "./cart/cart.component";
import { LanguageComponent } from "./language/language.component";
import { MessagesComponent } from "./messages/messages.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { ProfileComponent } from "./profile/profile.component";
import { SearchComponent } from "./search/search.component";
import { ThemeModeComponent } from "./theme-mode/theme-mode.component";
import { NavService } from "../../services/nav.service";
import { SearchService } from "../../services/search.service";
import { ClickOutsideDirective } from "../../directive/click-outside.directive";
import Swal from "sweetalert2";
import {AuthService} from "../../../auth/auth.service";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [CommonSvgIconComponent, SvgIconComponent, FeatherIconsComponent,
    FormsModule, RouterModule, CommonModule, ClickOutsideDirective,
    SearchComponent, LanguageComponent, NotificationsComponent,
    BookmarkComponent, ThemeModeComponent, MessagesComponent,
    CartComponent, ProfileComponent, BreadcrumbComponent, NgbTooltip],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})

export class HeaderComponent {

  public isFlip: boolean = false;
  public isSearchOpen: boolean = false;
  public open: boolean = false;

  constructor(
    public navService: NavService,
    public searchService: SearchService,
    private authService: AuthService
  ) { }

  sidebarToggle() {
    this.navService.collapseSidebar = !this.navService.collapseSidebar;
  }
  logOut() {
    Swal.fire({
      icon : 'warning',
      title : 'Attenzione!',
      text : 'Sei sicuro di voler uscire dal tuo account?',
      showCancelButton: true,
      confirmButtonText: "Conferma",
      cancelButtonText: "Annulla",
      confirmButtonColor: '#0DA759',
      cancelButtonColor: '#E44141',
      customClass : {
        cancelButton : 'order-1',
        confirmButton : 'order-2'
      }
    }).then((result) => {
      if(result.isConfirmed){
        this.authService.logOutApi().subscribe((res: any) => {
          if (res.success) {
            this.authService.logout()
          }
        });
      }else{
        Swal.close();
      }
    })
  }
}
